import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EIPAutoCompleteModule } from "eipauto-complete";
import { EIPDateRangePickerModule } from "eipdate-range-picker";
import { EdmsAutoCompleteComponent } from "./CommonComponents/autocomplete-component/autocomplete.component";
import { DynamicFieldDirective } from "./CommonComponents/dynamic-form/components/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "./CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { EipDateRangeComponent } from "./CommonComponents/dynamic-form/components/EIPDateRange/eipdaterange.component";
import { InputComponent } from "./CommonComponents/dynamic-form/components/input/input.component";
import { SelectComponent } from "./CommonComponents/dynamic-form/components/select/select.component";
import { EdmsCartComponent } from "./CommonComponents/edms-cart/edms-cart.component";
import { DragAndDropDirective } from "./CommonComponents/file-upload/drag-and-drop.directive";
import { FileUploadComponent } from "./CommonComponents/file-upload/file-upload.component";
import { LoaderComponent } from "./CommonComponents/loader/loader.component";
import { OptionsScrollDirective } from "./CommonComponents/optionsscroll/options-scroll.directive";
import { MaterialModule } from "./material.module";
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { EIPGridSettingsModule } from 'eipgrid-settings';
import { EIPTooltipModule } from 'eip-tooltip';
import { EIPToastAlertModule } from "eiptoast-alert";
import { EipDatePickerComponent } from "./CommonComponents/dynamic-form/components/EIPDatePicker/eipdatepicker.component";
import { EIPDatePickerModule } from "eipdate-picker";
import { FileListComponent } from './CommonComponents/file-list/file-list.component';
import { LabelComponent } from "./CommonComponents/dynamic-form/components/label/label.component";
import { CreateCommunicationComponent } from './CommonComponents/create-communication/create-communication.component';
import { PopupModule } from '@progress/kendo-angular-popup';
import { MenuModule } from '@progress/kendo-angular-menu';
import { EditorModule } from '@progress/kendo-angular-editor';
import { CreateMessageComponent } from './Modules/communication/create-message/create-message.component';
import { DocumentCartComponent } from './Modules/communication/document-cart/document-cart.component';
import { MessageCartComponent } from './Modules/communication/message-cart/message-cart.component';
import { EIPGeneralCartModule } from 'eipgeneral-cart';
import { ScheduleViewComponent } from './Modules/engineering-schedule/schedule-view/schedule-view.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ForgeViewerComponent } from "./CommonComponents/forge-viewer/forge-viewer.component";
import { CommonCartComponent } from "./Modules/communication/common-cart/common-cart.component";
import { DistributionListComponent } from "./Modules/communication/distribution-list/distribution-list.component";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { DocumentViewComponent } from "./Modules/repositorydocument/document-view/document-view.component";
import { EmployeeCartDialogComponent } from './Modules/repositorydocument/employee-cart-dialog/employee-cart-dialog.component';
import { FileCompareComponent } from "./CommonComponents/file-compare-component/file-compare.component";
import { ScheduleWorkflowhistoryComponent } from "./Modules/engineering-schedule/schedule-workflowhistory/schedule-workflowhistory.component";
import { CreateTransmittalComponent } from './Modules/transmittal/transmittal-creation/transmittal-creation.component';
import { TransmittalViewComponent } from './Modules/transmittal/transmittal-view/trasnsmittal-view.component';
import { DocumentWFCartComponent } from './Modules/transmittal/document-cart/document-cart.component';
import { TransmittalTemplateDirective } from './Modules/transmittal/transmittal-template/transmittal-template.directive';
import { CommonTransmittalTemplateComponent } from './Modules/transmittal/templates/template_common/transmittal-template-common.component';
import { HCITransmittalTemplateComponent } from './Modules/transmittal/templates/hci-transmittal/hci-transmittal-template.component';
import { DocumentViewGridComponent } from "./Modules/transmittal/document-grid/document-view-grid/document-view-grid.component";
import { DocumentMessageViewComponent } from 'src/app/CommonComponents/document-message-grid/document-message-view/document-message-view.component';
import { EIPMultiSelectAutoCompleteModule } from "eipmulti-select-auto-complete";
import { BulkDTNComponent } from './Modules/transmittal/bulkdtn/bulkdtn.component';
import { DTNReleaseComponent } from './Modules/transmittal/dtnrelease/dtnrelease.component';
import { DciFilterComponent } from "./CommonComponents/dci-filter/dci-filter.component";
import { DelayreasonComponent } from "./Modules/transmittal/delay-reason/delayreason/delayreason.component";
import { DynamickendoGridComponent } from './CommonComponents/Dynamic-Kendo-UI/Dynamic-kendo-Grid.component';
import { DynamickendoService } from './CommonComponents/Dynamic-Kendo-UI/Service/Dynamic-kendo.service';
import { ScheduleDocumentRevisionHistoryComponent } from './Modules/engineering-schedule/schedule-document-revision-history/schedule-document-revision-history.component';
import { ScheduleDocumentMailListComponent } from './Modules/engineering-schedule/schedule-document-mail-list/schedule-document-mail-list.component';
import { DatepickerFilterComponent } from './CommonComponents/datepicker-filter/datepicker-filter.component';
import { DropdownFilterComponent } from './CommonComponents/dropdown-filter/dropdown-filter.component';

@NgModule(  
  {
    declarations: [
      DynamicFormComponent,
      SelectComponent,
      InputComponent,
      LabelComponent,
      EipDateRangeComponent,
      EipDatePickerComponent,
      FileUploadComponent,
      FileListComponent,
      DynamicFieldDirective,
      DragAndDropDirective,
      LoaderComponent,
      OptionsScrollDirective,
      EdmsAutoCompleteComponent,
      EdmsCartComponent,      
      CreateCommunicationComponent,
      CreateMessageComponent,
      DocumentCartComponent,
      MessageCartComponent,
      ScheduleViewComponent,
      ForgeViewerComponent, 
      DistributionListComponent,  
      CommonCartComponent,
      DocumentViewComponent,
      EmployeeCartDialogComponent,
      FileCompareComponent,
      ScheduleWorkflowhistoryComponent,
      CreateTransmittalComponent,
      TransmittalViewComponent,
      DocumentWFCartComponent,
      TransmittalTemplateDirective,
      CommonTransmittalTemplateComponent,
      HCITransmittalTemplateComponent,
      DocumentViewGridComponent,
      DocumentMessageViewComponent,
      BulkDTNComponent, 
      DTNReleaseComponent,
      DciFilterComponent,
      DelayreasonComponent,
      DynamickendoGridComponent,
      ScheduleDocumentRevisionHistoryComponent,
      ScheduleDocumentMailListComponent,
      DatepickerFilterComponent,
      DropdownFilterComponent    
    ],
    imports: [
      FormsModule,
      ReactiveFormsModule,
      CommonModule,
      MaterialModule,
      EIPAutoCompleteModule,
      EIPMultiSelectAutoCompleteModule,
      EIPDateRangePickerModule,
      EIPDatePickerModule,
      GridModule,
      InputsModule,
      ButtonsModule,
      DialogsModule,
      DropDownsModule,
      DateInputsModule,
      ExcelModule,
      EIPGridSettingsModule,
      EIPTooltipModule,
      EIPToastAlertModule,
      EditorModule,
      PopupModule,
      MenuModule,
      TreeViewModule,
      EIPGeneralCartModule,
      MatSnackBarModule,

    ],
    entryComponents: [
      FileUploadComponent,
      FileListComponent,
      SelectComponent,
      InputComponent,
      EipDateRangeComponent,
      EipDatePickerComponent,
      LabelComponent,
      CreateCommunicationComponent,
      CreateMessageComponent,
      DocumentCartComponent,
      MessageCartComponent,
      ForgeViewerComponent,
      CommonCartComponent,
      ScheduleWorkflowhistoryComponent,
      EmployeeCartDialogComponent,
      FileCompareComponent,
      CreateTransmittalComponent,
      TransmittalViewComponent,
      DocumentWFCartComponent,
      CommonTransmittalTemplateComponent,
      HCITransmittalTemplateComponent,
      DocumentViewGridComponent,
      DocumentMessageViewComponent,
      BulkDTNComponent, 
      DTNReleaseComponent,
      DelayreasonComponent,
      DynamickendoGridComponent,
      ScheduleDocumentMailListComponent  
    ],
    exports: [
      DynamicFormComponent,
      FileUploadComponent,
      FileListComponent,
      DynamicFieldDirective,
      SelectComponent,
      InputComponent,
      LabelComponent,
      EipDateRangeComponent,
      EipDatePickerComponent,
      FileUploadComponent,
      DragAndDropDirective,
      LoaderComponent,
      EdmsAutoCompleteComponent,    
      EdmsCartComponent,
      CreateCommunicationComponent,
      ScheduleViewComponent,
      ForgeViewerComponent,
      DistributionListComponent,
      CommonCartComponent,
      DocumentViewComponent,
      FileCompareComponent,
      CreateTransmittalComponent,
      TransmittalViewComponent,
      DocumentWFCartComponent,
      TransmittalTemplateDirective,
      CommonTransmittalTemplateComponent,
      HCITransmittalTemplateComponent,
      DocumentViewGridComponent,
      DocumentMessageViewComponent,
      BulkDTNComponent,
      DTNReleaseComponent,
      DciFilterComponent,
      DelayreasonComponent,
      DynamickendoGridComponent,
      ScheduleDocumentRevisionHistoryComponent,
      ScheduleDocumentMailListComponent,
      DatepickerFilterComponent,
      DropdownFilterComponent   
    ],
    providers: [DynamickendoService]
  }
)
export class EDMSCommonModule {

}
 